import { put, take } from "typed-redux-saga";
import workerChannel from "./worker.channel";
import { workerActions } from "../../reducers/worker.slice";

function* logisticRegressionWorkerSaga() {
  const webWorker = new Worker(
    new URL("../workers/logistic-regression.worker.js", import.meta.url)
  );

  const channel = workerChannel(webWorker);

  while (true) {
    try {
      const action = yield* take(workerActions.logisticRegression);
      webWorker.postMessage(action.payload);

      const data = (yield* take(channel)) as {
        key: string;
        balancedAccuracy: number;
      };

      yield* put(
        workerActions.setLogisticRegression({
          key: action.payload.key,
          balancedAccuracy: data.balancedAccuracy,
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export default logisticRegressionWorkerSaga;
